export default "__VITE_ASSET__Ol58DSsq__"